var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pnlTitleArea"},[_c('img',{staticClass:"imgCustomTitle",attrs:{"src":_vm.iconSrc}}),_c('label',{staticClass:"lblTitle"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }